import { Link } from "react-router-dom";

const SHOP_LINKS = [
  { label: "All Products", href: "#shop" },
  { label: "Graphic Tees", href: "#categories" },
  { label: "Heavyweight Hoodies", href: "#categories" },
  { label: "Caps & Accessories", href: "#categories" },
];

const HELP_LINKS = [
  { label: "Shipping & Fulfilment", href: "#about" },
  { label: "Returns & Exchanges", href: "#about" },
  { label: "Size Guide", href: "#shop" },
  { label: "Contact Us", href: "#newsletter" },
];

export const SiteFooter = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-zinc-800 bg-ink">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-14 sm:grid-cols-2 sm:px-8 lg:grid-cols-4 lg:px-12">
        <div>
          <Link to="/gb/en/home.html" data-testid="footer-logo-link">
            <img src="/assets/logo-orange.png" alt="Tiger Clothing" className="h-16 w-auto" />
          </Link>
          <p className="mt-4 font-body text-sm leading-relaxed text-zinc-400">
            Fierce Attire. UK streetwear, printed on demand and shipped worldwide.
          </p>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-xs font-bold uppercase tracking-[0.2em] text-white">Shop</h4>
          <ul className="space-y-2.5">
            {SHOP_LINKS.map((link) => (
              <li key={link.label}>
                <a href={link.href} data-testid={`footer-shop-${link.label.toLowerCase().replace(/\s+/g, "-")}`} className="font-body text-sm text-zinc-400 transition-colors hover:text-tiger">
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-xs font-bold uppercase tracking-[0.2em] text-white">Help</h4>
          <ul className="space-y-2.5">
            {HELP_LINKS.map((link) => (
              <li key={link.label}>
                <a href={link.href} data-testid={`footer-help-${link.label.toLowerCase().replace(/\s+/g, "-")}`} className="font-body text-sm text-zinc-400 transition-colors hover:text-tiger">
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-xs font-bold uppercase tracking-[0.2em] text-white">Contact</h4>
          <ul className="space-y-2.5 font-body text-sm text-zinc-400">
            <li data-testid="footer-email">hello@tiger-clothing.co.uk</li>
            <li>United Kingdom</li>
            <li>
              <Link to="/gb/en/admin.html" data-testid="footer-admin-link" className="text-zinc-500 transition-colors hover:text-tiger">
                Admin Login
              </Link>
            </li>
            <li className="pt-2">
              <span className="inline-block border border-tiger/40 bg-tiger/10 px-3 py-1.5 font-heading text-[10px] font-bold uppercase tracking-widest text-tiger">
                Fulfilled by Printful
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-zinc-800">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 sm:flex-row sm:px-8 lg:px-12">
          <p className="font-body text-xs text-zinc-500" data-testid="footer-copyright">
            © 2026 Tiger Clothing — www.tiger-clothing.co.uk. All rights reserved.
          </p>
          <p className="font-display text-xs uppercase tracking-[0.3em] text-zinc-600">Fierce Attire</p>
        </div>
      </div>
    </footer>
  );
};
